import { PageLeftSplitLayoutContext } from 'pages/Project/Common/Layouts/PageLayoutContext';

import type { CSSProperties, PropsWithChildren } from 'react';
import { useContext } from 'react';

import Style from './toolBar.module.css';

type IToolbar = PropsWithChildren<{
    flex?: boolean;
    fullLine?: boolean;
}>;

export const Toolbar = (props: IToolbar) => {
    const { flex, children, fullLine } = props;
    const { isLeftPanelOpened } = useContext(PageLeftSplitLayoutContext);

    return (
        <div
            className={fullLine ? Style.fullLine : Style.line}
            style={
                {
                    paddingBottom: 24,
                    display: flex ? 'flex' : 'block',
                    marginBottom: '12px',
                    '--leftPosition': isLeftPanelOpened ? '-34px' : '-24px',
                } as CSSProperties
            }
        >
            {children}
        </div>
    );
};

Toolbar.displayName = 'Toolbar';
